import { PayloadAction } from '@reduxjs/toolkit';
import { IGetByFilterResponse, IListParams } from '@tacans/shared-marketplace-layer';
import { useCallback } from 'react';
import { useFetchUserList } from 'src/features/common/user/hooks/user-list.hooks';
import { useAppDispatch, useAppSelector } from 'src/hooks/app';
import { selectTrendingNftsEntities, selectTrendingNftsLoading } from '../ducks/trending-nfts/trending-nfts.selectors';
import { actions } from '../ducks/trending-nfts/trending-nfts.slice';
import { trendingNftsFetchThunk } from '../ducks/trending-nfts/trending-nfts.thunk';

export const useTrendingNfts = () => {
    const dispatch = useAppDispatch();
    const fetchUserList = useFetchUserList();

    const trendingNfts = useAppSelector(selectTrendingNftsEntities);
    const isLoading = useAppSelector(selectTrendingNftsLoading);

    const fetch = useCallback(
        async (request: IListParams) => {
            const { payload } = (await dispatch(
                trendingNftsFetchThunk(request)
            )) as PayloadAction<IGetByFilterResponse>;
            if (payload.list) {
                fetchUserList({
                    wallets: payload.list.map((nft) => ({
                        address: nft.author,
                        blockchainId: nft.blockchainId,
                    })),
                });
            }
        },
        [dispatch, fetchUserList]
    );

    const clear = useCallback(() => {
        dispatch(actions.clear());
    }, [dispatch]);

    return { fetch, clear, trendingNfts, isLoading };
};
